import { useEffect, useRef } from 'react';

// A subtle animated gold cursor trail — desktop only, respects reduced-motion.
const COLORS = ['#e7d3a1', '#c6a15b', '#f7f3ec', '#d8b96a'];

const CursorTrail = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isTouch || reduce) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let w, h;
    const resize = () => {
      w = canvas.width = window.innerWidth * dpr;
      h = canvas.height = window.innerHeight * dpr;
      canvas.style.width = window.innerWidth + 'px';
      canvas.style.height = window.innerHeight + 'px';
    };
    resize();
    window.addEventListener('resize', resize);

    const points = [];
    let idx = 0;
    const onMove = (e) => {
      for (let i = 0; i < 2; i++) {
        points.push({
          x: e.clientX * dpr,
          y: e.clientY * dpr,
          life: 1,
          size: (Math.random() * 3 + 1.6) * dpr,
          vx: (Math.random() - 0.5) * 0.7 * dpr,
          vy: (Math.random() - 0.5) * 0.7 * dpr,
          color: COLORS[idx++ % COLORS.length],
        });
      }
      if (points.length > 220) points.splice(0, points.length - 220);
    };
    window.addEventListener('mousemove', onMove);

    let raf;
    const loop = () => {
      ctx.clearRect(0, 0, w, h);
      for (let i = points.length - 1; i >= 0; i--) {
        const p = points[i];
        p.life -= 0.032;
        p.x += p.vx;
        p.y += p.vy;
        if (p.life <= 0) { points.splice(i, 1); continue; }
        ctx.globalAlpha = Math.max(p.life, 0) * 0.75;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size * p.life, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={canvasRef} style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999 }} aria-hidden="true" />;
};

export default CursorTrail;
